export default "__VITE_ASSET__DbvDti_E__"